import React, { useState } from 'react';
import { ClassItemEdit } from './ClassItemEdit';
import { ClassRoundsTable } from './ClassRoundsTable';
export const ClassItemView = (props) => {
    const { event_id, competition_id, classItem, disabled } = props;
    const [visibleEdit, setVisibleEdit] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(ClassRoundsTable, { event_id: event_id, competition_id: competition_id, classItem: classItem, disabled: disabled }),
        React.createElement(ClassItemEdit, { competition_id: competition_id, classItem: classItem, visible: visibleEdit, setVisible: setVisibleEdit })));
};
